export const application = 'academy-prod';

export const apiURL = '/bright/api';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
